import { Route, Redirect, Switch } from "react-router-dom";
import { AuthenticatedRoute, PublicRoute } from "./shared/Routing";
import NotFound from './pages/public/NotFound';
import LoginPortal from './pages/public/LoginPortal';
import FamilyRegistration from './pages/public/FamilyRegistration';
import CredentialsSetup from './pages/public/CredentialsSetup';
import AdminDashboard from './pages/admin/AdminDashboard'
import FamilyLanding from './pages/family/FamilyLanding';
import ParentSetup from './pages/family/ParentSetup';
import HouseholdSetup from './pages/family/HouseholdSetup';
import PhotoVideoReleaseForm from './pages/family/PhotoVideoReleaseForm';
import TutoringPaymentPage from './pages/family/TutoringPaymentPage';
import ContactUs from './pages/family/ContactUs';
import PublicContactUs from "./pages/public/PublicContactUs";
import IdleSessionTimeoutModal from './shared/IdleSessionTimeoutModal';
import ResetPassword from "./pages/public/ResetPassword";
import SetNewPasswordPage from "./pages/public/SetNewPassword";
import ChildPage from "./pages/family/ChildPage";
import StaffRegistration from "./pages/staff/StaffRegistration";
import StaffDashboard from "./pages/staff/StaffDashboard";
import PrivacyPolicy from "./pages/public/PrivacyPolicy";
import MobileTerms from "./pages/public/MobileTerms";
import MFALogin from "./pages/public/MFALogin";
import ErrorBoundary from "./shared/ErrorBoundary";
import ErrorFallback from "./shared/ErrorFallback";
import Page from "./shared/Page";
import './App.css';

export default function App() {
    return (
        <main className="app">
            <ErrorBoundary fallback={<Page title="Error"><ErrorFallback unrecoverable /></Page>}>
                {!import.meta.env.VITE_DISABLE_TIMEOUT && <IdleSessionTimeoutModal logOutAfterSeconds={30 * 60} />}
                <Switch>
                    {/* Default Route is Family Portal */}
                    <PublicRoute exact path="/" component={() => <Redirect to="/family-portal" />} />

                    {/* Public Pages */}
                    <PublicRoute exact path="/admin-portal" component={() => <LoginPortal portalType="ADMIN" />} />
                    <PublicRoute exact path="/staff-portal" component={() => <LoginPortal portalType="STAFF" />} />
                    <PublicRoute exact path="/family-portal" component={() => <LoginPortal portalType="FAMILY" />} />
                    <PublicRoute exact path="/register" component={FamilyRegistration} />
                    <PublicRoute exact path="/contact-us" component={PublicContactUs} />
                    <PublicRoute exact path="/admin-credentials-setup/:token" component={() => <CredentialsSetup type="Admin" />} />
                    <PublicRoute exact path="/staff-credentials-setup/:token" component={() => <CredentialsSetup type="Staff" />} />
                    <PublicRoute exact path="/reset-password" component={ResetPassword} />
                    <PublicRoute exact path="/set-new-password/:token" component={SetNewPasswordPage} />
                    <PublicRoute exact path="/mfa-login/:token" component={MFALogin} />

                    {/* Family Pages */}
                    <AuthenticatedRoute exact path="/home" component={FamilyLanding} role="FAMILY" status="Profile Setup Complete" />
                    <AuthenticatedRoute exact path="/child/add" component={() => <ChildPage addNew />} role="FAMILY" status="Profile Setup Complete" />
                    <AuthenticatedRoute exact path="/child/:childId" component={ChildPage} role="FAMILY" status="Profile Setup Complete" />
                    <AuthenticatedRoute exact path="/tutor" component={TutoringPaymentPage} role="FAMILY" status="Profile Setup Complete" />
                    <AuthenticatedRoute exact path="/contact" component={ContactUs} role="FAMILY" status="Profile Setup Complete" />
                    <AuthenticatedRoute exact path="/setup/parent" component={ParentSetup} role="FAMILY" status="Parent Setup Pending" />
                    <AuthenticatedRoute exact path="/setup/household" component={HouseholdSetup} role="FAMILY" status="Household Setup Pending" />
                    <AuthenticatedRoute exact path="/photo-video-form" component={PhotoVideoReleaseForm} role="FAMILY" status="Photo Video Form Pending" />

                    {/* Admin Pages */}
                    <AuthenticatedRoute path="/admin" component={AdminDashboard} role="ADMIN" />
                    <AuthenticatedRoute exact path="/family/:familyId" component={FamilyLanding} role="ADMIN" />
                    <AuthenticatedRoute exact path="/family/:familyId/child/add" component={() => <ChildPage addNew />} role="ADMIN" />
                    <AuthenticatedRoute exact path="/family/:familyId/child/:childId" component={ChildPage} role="ADMIN" />

                    {/* Staff Pages */}
                    <AuthenticatedRoute path="/staff" component={StaffDashboard} role="STAFF" status={["Onboarding Pending", "Active"]} />
                    <AuthenticatedRoute exact path="/register-staff" component={StaffRegistration} role="STAFF" status="Registration Pending" />

                    <Route exact path="/privacy" component={PrivacyPolicy} />
                    <Route exact path="/mobile-tos" component={MobileTerms} />
                    <Route component={NotFound} />
                </Switch>
            </ErrorBoundary>
        </main>
    );
}
